import { useState, useEffect, useContext } from "react";
import { Remediations_func } from "../../../api/devices/remediation/remediations_func";
import { Remediations_autoheal_func } from "../../../api/devices/remediation/remediations_autoheal_func";
import { Remediations_scheduler_func } from "../../../api/devices/remediation/remediations_scheduler_func";
import { useTracking } from "react-tracking";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Stack, StackItem } from "@fluentui/react";
import { CSVLink } from "react-csv";
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Theme, createLightTheme, createDarkTheme, BrandVariants, Card, ProgressBar, ButtonProps } from "@fluentui/react-components";
import { BookTemplate20Regular, LinkSquare20Regular, Filter20Filled, FilterDismiss20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Save20Regular, Info20Filled, ArrowMaximize20Regular, DismissSquare24Filled, Dismiss16Regular } from "@fluentui/react-icons";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { ToastComponent } from "../../../components/toast/toast.component";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import DialogBox from "../../../components/dialog/dialog.component";
import { GlobalContext } from "../../../hooks/globalContext";
import { fullscreenIcon, lightTheme, messageTheme, primaryIcon, exitIcon, secondaryIcon, overflowDivider, SubSectionResponsive, DynamicBoxingCSS, parentHome, wraperStyle, dashboardTheme, BreadcrumbsBorder } from "../../../styles/customStyles";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import { usePermissionStore } from "../../../Store/permissionStore";
import { CheckBox } from "../../../components/checkbox/checkbox_component";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { Remediations_assignment_func } from "./remediations_assignment_func";
import { InfoBar } from "../../../components/infoBar/infoBar.component";
import { AuditPages } from "../../../components/side_menu/InlineSidenav";

const handleExportCSV = () => {
  // Programmatically trigger the CSV export link
  const csvExportLink = document.getElementById("csv-export-link");
  if (csvExportLink) { csvExportLink.click(); }
};

export const Remediation_Attach_Detach = () => {
  const contextValue: any = useContext(GlobalContext);
  var tenantName = contextValue.tenantName;
  const dartNo = contextValue.dartNo;
  const navigate = useNavigate();

  const [final_data, set_final_data]: any = useState(null);
  const [tableData, setTableData] = useState([]);
  const [leftOpen, setLeftOpen] = useState(false);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [exportDetails, setExportDetails]: any = useState([]);
  const [toastMessage, setToastMessage] = useState('');
  const [errorToast, setErrorToast] = useState(false);
  const [messagebar1, setmessagebar1] = useState(false);
  const [messagebar2, setmessagebar2] = useState(false);
  const [isSaveEnabled, setSaveEnabled] = useState(false);
  const [isRefresh, setRefresh]: any = useState(false);
  const [isToast, setIsToast] = useState(false);
  const [refreshToast, setRefreshToast]: any = useState(false);
  const [rowID, setRowID]: any = useState(null);
  const [deviceCnt, setDeviceCnt]: any = useState(0);
  const [groupDeviceCnt, setGroupDeviceCnt]: any = useState({});
  const [saveBtnClicked, setSaveBtnClicked]: any = useState(false);
  const [defaultSelectedRows, setDefaultSelectedRows]: any = useState([]);
  const [previousSelectedGroups, setPreviousSelectedGroups]: any = useState([]);
  const [attachmentGrp, setAttachmentGrp]: any = useState([]);
  const [detachmentGrp, setDetachmentGrp]: any = useState([]);
  const [showMessage, setShowMessage] = useState(false);
  const [isProgressLoading, setProgressLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  const { permissions } = usePermissionStore();

  var automationType = contextValue.automationDetails.automationType;
  var attachmentArr: any = [];
  var detachmentArr: any = [];

  const [allAttachmentGrp, setAllAttachmentGrp] = useState(['']);
  const [allDetachmentGrp, setAllDetachmentGrp] = useState(['']);
  const [attachmentStatus, setAttachmentStatus] = useState(false);

  const handleBothSetMessage = () => {
    if (!previousSelectedGroups.includes('All Devices') && contextValue.selectedRowIdInTable.includes('All Devices')) {
      if (previousSelectedGroups.length == 0) {
        detachmentArr = [];
        setDetachmentGrp(detachmentArr);
        setAllDetachmentGrp(detachmentArr);
      } else {
        detachmentArr = contextValue.selectedRowIdInTable.filter((val: any) => val != 'All Devices')
        setDetachmentGrp(detachmentArr);
        setAllDetachmentGrp(detachmentArr);
      }
      attachmentArr = ['All Devices'];
      setAttachmentGrp(attachmentArr);
      setAllAttachmentGrp(attachmentArr);
    } else if (previousSelectedGroups.includes('All Devices') && contextValue.selectedRowIdInTable.includes('All Devices')) {
      detachmentArr = ['All Devices'];
      setDetachmentGrp(detachmentArr);
      setAllDetachmentGrp(detachmentArr);

      attachmentArr = contextValue.selectedRowIdInTable.filter((val: any) => !previousSelectedGroups.includes(val));
      setAttachmentGrp(attachmentArr);
      setAllAttachmentGrp(attachmentArr);

    } else {
      detachmentArr = previousSelectedGroups.filter((val: any) => !contextValue.selectedRowIdInTable.includes(val));
      setDetachmentGrp(detachmentArr);
      setAllDetachmentGrp(detachmentArr);

      attachmentArr = contextValue.selectedRowIdInTable.filter((val: any) => !previousSelectedGroups.includes(val));
      setAttachmentGrp(attachmentArr);
      setAllAttachmentGrp(attachmentArr);
    }

    console.log("previousSelectedGroups=", previousSelectedGroups, " checked=", contextValue.selectedRowIdInTable, " attached=", attachmentArr, " unattached=", detachmentArr);

    setSaveBtnClicked(true);
  };

  // useEffect(() => {
  //   var detachmentVal = allDetachmentGrp.length > 0 ? allDetachmentGrp[0] : 0;
  //   var attachmentVal = allAttachmentGrp.length > 0 ? allAttachmentGrp[0] : 0;    

  //   if(attachmentVal === 0 && detachmentVal === 0){
  //     var detachmentExportArr = [];
  //     var attachmentExportArr = [];

  //     if(!previousSelectedGroups.includes('All Devices') && contextValue.selectedRowIdInTable.includes('All Devices')) {
  //       if (previousSelectedGroups.length == 0) {
  //         detachmentExportArr = [];
  //       }
  //       else {
  //         detachmentExportArr = contextValue.selectedRowIdInTable.filter((val: any) => val != 'All Devices')
  //       }
  //       attachmentExportArr = ['All Devices'];
  //     }else if (previousSelectedGroups.includes('All Devices') && contextValue.selectedRowIdInTable.includes('All Devices')) {
  //       detachmentExportArr = ['All Devices'];

  //       attachmentExportArr = contextValue.selectedRowIdInTable.filter((val: any) => !previousSelectedGroups.includes(val));
  //     }else {
  //       detachmentExportArr = previousSelectedGroups.filter((val: any) => !contextValue.selectedRowIdInTable.includes(val));

  //       attachmentExportArr = contextValue.selectedRowIdInTable.filter((val: any) => !previousSelectedGroups.includes(val));
  //     }

  //     var summary = '';
  //     if(attachmentExportArr.length > 0 && detachmentExportArr.length > 0){
  //       summary = `${contextValue.automationDetails.automationName} remediation has attached to ${attachmentExportArr.length} configured ${attachmentExportArr.length > 1 ? 'groups' : 'group'} and detached from ${detachmentExportArr.length} configured ${detachmentExportArr.length > 1 ? 'groups' : 'group'}`;
  //     }else if(attachmentExportArr.length > 0 && detachmentExportArr.length < 1){
  //       summary = `${contextValue.automationDetails.automationName} remediation has attached to ${attachmentExportArr.length} configured ${attachmentExportArr.length > 1 ? 'groups' : 'group'}`;
  //     }else if(attachmentExportArr.length < 1 && detachmentExportArr.length > 0){
  //       summary = `${contextValue.automationDetails.automationName} remediation has detached from ${detachmentExportArr.length} configured ${detachmentExportArr.length > 1 ? 'groups' : 'group'}`;
  //     }

  //     userActivity('Add', `{"remediationName":"${contextValue.automationDetails.automationName}","type":"${automationType}","attachedGroups":"${attachmentExportArr}","detachedGroups":"${detachmentExportArr}","summary":"${summary}"}`);

  //     setTimeout(() => {
  //       navigate("/manage/devices/remediation");
  //     }, 4000);
  //   }else if(allDetachmentGrp.length > 0 && allDetachmentGrp[0] !== ''){
  //     setDetachmentGrp([detachmentVal]);

  //     setSaveBtnClicked(true);
  //   }else if(allAttachmentGrp.length > 0 && allAttachmentGrp[0] !== ''){
  //     setDetachmentGrp([]);
  //     setAttachmentGrp([attachmentVal]);

  //     contextValue.selectedRowIdInTable.length > 0 && setSaveBtnClicked(true);
  //   }
  // },[allAttachmentGrp, allDetachmentGrp]);

  const handleButtonClick = () => { setShowMessage(true); };
  const [isPopoverOpenEnable, setisPopoverOpenEnable] = useState(false);
  const HandleScreen = () => { console.log('pop over', isPopoverOpenEnable); setisPopoverOpenEnable(!isPopoverOpenEnable) };

  const handle = useFullScreenHandle();

  const truncateSelectedDevices = (selectedDevices: string[]) => {
    const MAX_DISPLAY = 3;
    if (selectedDevices.length > MAX_DISPLAY) {
      const truncatedList = selectedDevices.slice(0, MAX_DISPLAY);
      truncatedList.push(`${selectedDevices.length - MAX_DISPLAY}+ more`);
      return truncatedList;
    }
    return selectedDevices;
  };

  //data table column name code starts here
  var columns = [
    { key: "group_name", label: <Body1Strong> Group Name </Body1Strong> },
    { key: "device_cnt", label: <Body1Strong> Count of Devices </Body1Strong> },
  ];
  //data table column name code ends here

  // overflow set contents code starts here
  var overFlowComponent = {
    data: (
      <>
        <StackItem>
          <DialogBox
            headerButton={
              <Button shape="circular" appearance="transparent" size="small"
                disabled={isSaveEnabled ? false : true} >
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem> {isSaveEnabled ? (<Save20Regular {...primaryIcon} />) : (<Save20Regular {...secondaryIcon} />)} </StackItem>
                  <StackItem> <Caption1> Save </Caption1> </StackItem>
                </Stack>
              </Button>
            }

            // console.log("previousSelectedGroups=",previousSelectedGroups," checked=",contextValue.selectedRowIdInTable," attached=",attachmentArr," unattached=",detachmentArr);

            // content= {(!previousSelectedGroups.includes('All Devices') && contextValue.selectedRowIdInTable.includes('All Devices')) ?  "Please confirm your decision to proceed with this change. The policy will be assigned to 'All devices'." : (previousSelectedGroups.includes('All Devices') && contextValue.selectedRowIdInTable.length == 0) ?  "Please confirm your decision to proceed with this change. The policy will be removed from 'All devices'." : `This change will be pushed to all connected devices that belong to the following groups:\r\n${contextValue.selectedRowIdInTable.join(",")}`}

            content={
              <>
                <Stack tokens={{ childrenGap: 5 }}>
                  <StackItem>
                    {
                      (!previousSelectedGroups.includes('All Devices') && contextValue.selectedRowIdInTable.includes('All Devices'))
                        ? "Are you sure you want to enable the automation for all devices?"
                        :
                        (previousSelectedGroups.length > 0 && contextValue.selectedRowIdInTable.length === 0) ? `Are you sure you want to detach the automation?`
                          : `Are you sure you want to enable the automation for the selected device classifications
                        :\r\n${truncateSelectedDevices(contextValue.selectedRowIdInTable.filter((val: any) => !previousSelectedGroups.includes(val))).join(', ')}`
                    }
                  </StackItem>
                </Stack>

              </>
            }

            footer={
              <>
                <Stack horizontal tokens={{ childrenGap: 10 }}>
                  <StackItem> <Button shape="circular" appearance="primary" onClick={handleBothSetMessage} size="small"> Confirm </Button> </StackItem>
                  <StackItem> <Button shape="circular" size="small" onClick={() => { setmessagebar1(false); }}> Cancel </Button> </StackItem>
                </Stack>
              </>
            }
          />
        </StackItem>

        <StackItem><Divider vertical /></StackItem>

        <StackItem>
          <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setCurrentPageNo(1); setRefresh(true); setLoading(true); }}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> {loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />} </StackItem>
              <StackItem> <Caption1> Refresh </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>

        <StackItem>
          <CSVLink id="csv-export-link" data={exportData} filename={`${contextValue.automationDetails.automationName}_${automationType}.csv`}>
          </CSVLink>
          <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => { setExportBtnClicked(true); /*userActivity('Export', `{"summary":"Configured groups list exported"}`);*/ }}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> {loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
              <StackItem> <Caption1> Export </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>

        {/* <StackItem>
          <Button shape="circular" appearance="subtle" size="small">
            <Stack tokens={{childrenGap:5}} horizontal>
              <StackItem> <Settings20Regular {...primaryIcon}/> </StackItem>
              <StackItem> <Caption1> Manage View </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>
        
        <StackItem>
          <PopOver
            headerButton=
            {
              <>
                <Button shape="circular" appearance="transparent" size="small" onClickCapture={() => setCurrentPageNo(1)} onClick={HandleScreen}  
                  disabled={ isSaveEnabled ? false :true}>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem> <Save20Regular {...primaryIcon} /> </StackItem>
                  <StackItem> <Caption1> Save </Caption1> </StackItem>
                  </Stack>
                </Button>
              </>
            }
            content={ <> Please confirm your decision to proceed with this change. The policy will be assigned to ‘All devices’. </> }
            footer={
              <>
              <Stack horizontal tokens={{childrenGap:10}}>
                  <StackItem><Button shape="circular" appearance="primary" onClick={handleBothSetMessage} onClickCapture={HandleScreen} size="small">Confirm</Button> </StackItem>
                  <StackItem><Button shape="circular" size="small" onClick={() => { setmessagebar1(false); }} onClickCapture={HandleScreen}>Cancel</Button></StackItem>
                </Stack>
              </>
            }
          />
        </StackItem> */}
        <StackItem grow shrink>
          <Stack horizontalAlign="end">
            <StackItem grow shrink>
              <FullScreenButton handle={handle} />
            </StackItem>
          </Stack>
        </StackItem>
      </>
    ),
  };
  // overflow set contents code ends here

  var tempTableData: any = [];
  useEffect(() => {
    var tempExportData: any = [];

    exportDetails?.length > 0 && tempExportData.push({
      'Group Name': 'All Devices',
      'Device Count': deviceCnt,
      'Status': previousSelectedGroups.includes('All Devices') ? 'Attached' : 'Not Attached'
    });

    exportDetails?.length > 0 && exportDetails.map((val: any) => {
      tempExportData.push({
        'Group Name': val.classificationName,
        'Device Count': groupDeviceCnt[`${val.classificationName}`],
        'Status': previousSelectedGroups.includes(val.classificationName) ? 'Attached' : 'Not Attached'
      });
    });

    setExportData(tempExportData);
  }, [exportDetails]);

  useEffect(() => {
    exportData.length > 0 && document.getElementById('csv-export-link')?.click();
  }, [exportData]);

  useEffect(() => {
    setmessagebar2(false);
    var defaultSelectedIds: any = [];
    console.log("previousSelectedGroups=", previousSelectedGroups);

    {
      permissions.includes("all") || permissions.includes("remediation_Fullaccess") ?
      deviceCnt > 0 && tempTableData.push({
        id: 'All Devices',
        group_name: { label: <Caption1> All Devices </Caption1>, icon: "", id: 1, },
        device_cnt: { label: <Caption1> {deviceCnt} </Caption1>, icon: "", status: "", },
      })
      :
      deviceCnt > 0 && tempTableData.push({
        checkbox: "hide",
        id: 'All Devices',
        group_name: { label: <Caption1> All Devices </Caption1>, icon: "", id: 1, },
        device_cnt: { label: <Caption1> {deviceCnt} </Caption1>, icon: "", status: "", },
      });
    }

    previousSelectedGroups.includes('All Devices') && defaultSelectedIds.push(0);

    final_data !== undefined && final_data !== null
      ? final_data.map((val: any, i: any) => {
        previousSelectedGroups.includes(val.classificationName) && defaultSelectedIds.push(i + 1);

        {
          permissions.includes("all") || permissions.includes("remediation_Fullaccess") ?
          tempTableData.push({
            id: val.classificationName,
            checkbox: contextValue.selectedRowIdInTable.includes("All Devices") ? "hide" : "show",
            group_name: { label: <Caption1> {val.classificationName} </Caption1>, icon: "", id: `${i}` },
            device_cnt: { label: <Caption1> {groupDeviceCnt[`${val.classificationName}`]} </Caption1>, icon: "", status: "" }
          })
          :
          tempTableData.push({
            id: val.classificationName,
            checkbox: "hide",
            group_name: { label: <Caption1> {val.classificationName} </Caption1>, icon: "", id: `${i}` },
            device_cnt: { label: <Caption1> {groupDeviceCnt[`${val.classificationName}`]} </Caption1>, icon: "", status: "" }
          });
        }
      }) : (tempTableData = []);

    // if(contextValue.selectedRowIdInTable.length > 1 && contextValue.selectedRowIdInTable.includes("All Devices")){
    //   contextValue.setSelectedRowIdInTable(["All Devices"])
    // }


    setDefaultSelectedRows(defaultSelectedIds);
    tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
    setTimeout(() => {
      final_data !== undefined && final_data !== null && setLoading(false);
    }, 500);
  }, [final_data, groupDeviceCnt, previousSelectedGroups, contextValue.selectedRowIdInTable]);
  // data table values append code ends here

  useEffect(() => {
    contextValue.setSelectedRowIdInTable([]);
  }, []);

  useEffect(() => {
    contextValue.setSelectedRowIdInTable(previousSelectedGroups);
  }, [previousSelectedGroups]);

  useEffect(() => {
    var newCheckedVal = contextValue.selectedRowIdInTable.filter((val: any) => !previousSelectedGroups.includes(val));

    console.log("checked=", contextValue.selectedRowIdInTable, "previousSelectedGroups=", previousSelectedGroups, "newCheckedVal", newCheckedVal);

    (newCheckedVal?.length > 0 || (previousSelectedGroups?.length > 0 && contextValue.selectedRowIdInTable?.length >= 0 && JSON.stringify(previousSelectedGroups) !== JSON.stringify(contextValue.selectedRowIdInTable))) ? setSaveEnabled(true) : setSaveEnabled(false);
  }, [contextValue.selectedRowIdInTable]);

  useEffect(() => {
    var detachmentExportArr = [];
    var attachmentExportArr = [];

    if (!previousSelectedGroups.includes('All Devices') && contextValue.selectedRowIdInTable.includes('All Devices')) {
      if (previousSelectedGroups.length == 0) {
        detachmentExportArr = [];
      }
      else {
        detachmentExportArr = contextValue.selectedRowIdInTable.filter((val: any) => val != 'All Devices')
      }
      attachmentExportArr = ['All Devices'];
    }
    else if (previousSelectedGroups.includes('All Devices') && contextValue.selectedRowIdInTable.includes('All Devices')) {
      detachmentExportArr = ['All Devices'];

      attachmentExportArr = contextValue.selectedRowIdInTable.filter((val: any) => !previousSelectedGroups.includes(val));
    }
    else {
      detachmentExportArr = previousSelectedGroups.filter((val: any) => !contextValue.selectedRowIdInTable.includes(val));

      attachmentExportArr = contextValue.selectedRowIdInTable.filter((val: any) => !previousSelectedGroups.includes(val));
    }

    var summary = '';
    if (attachmentExportArr.length > 0 && detachmentExportArr.length > 0) {
      summary = `${contextValue.automationDetails.automationName} remediation has attached to ${attachmentExportArr.length} configured ${attachmentExportArr.length > 1 ? 'groups' : 'group'} and detached from ${detachmentExportArr.length} configured ${detachmentExportArr.length > 1 ? 'groups' : 'group'}`;
    } else if (attachmentExportArr.length > 0 && detachmentExportArr.length < 1) {
      summary = `${contextValue.automationDetails.automationName} remediation has attached to ${attachmentExportArr.length} configured ${attachmentExportArr.length > 1 ? 'groups' : 'group'}`;
    } else if (attachmentExportArr.length < 1 && detachmentExportArr.length > 0) {
      summary = `${contextValue.automationDetails.automationName} remediation has detached from ${detachmentExportArr.length} configured ${detachmentExportArr.length > 1 ? 'groups' : 'group'}`;
    }

    // userActivity('Add', `{"remediationName":"${contextValue.automationDetails.automationName}","attachedGroups":"${attachmentExportArr}","detachedGroups":"${detachmentExportArr}","summary":"${summary}"}`);

    saveBtnClicked && setProgressLoading(true);
  }, [saveBtnClicked]);

  useEffect(() => {
    if (saveBtnClicked && (automationType === 'selfhelp' || automationType === 'proactive' || automationType === 'scheduler' || automationType === 'usersurvey' || automationType === 'policy' || automationType === 'autoheal' || automationType === 'data_collection' || automationType === 'default_dart' || automationType === 'app policy')) {

      setProgressLoading(false);
      setmessagebar2(true);
      setTimeout(() => {
        (automationType === 'data_collection' || automationType === 'default_dart') ? navigate("/manage/devices/datacollection") : navigate("/manage/devices/remediation");
      }, 4000);
    }
  }, [attachmentStatus])

  useEffect(() => {
    var detachmentVal = allDetachmentGrp.length > 0 ? allDetachmentGrp[0] : 0;
    var attachmentVal = allAttachmentGrp.length > 0 ? allAttachmentGrp[0] : 0;

    (messagebar2 || errorToast) && detachmentVal === 0 && attachmentVal === 0 && setProgressLoading(false);
  }, [messagebar2, errorToast]);

  useEffect(() => {
    if (totalRecords === 0 && deviceCnt > 0) {
      setTotalRecords(1);
      setTotalPages(1);
    } else if (totalRecords > 0 && deviceCnt > 0 && currentPageNo === 1) {
      setTotalRecords(totalRecords + 1);
      setTotalPages(1);
    }
  }, [deviceCnt]);

  useEffect(() => {
    const pageNo = (currentPageNo - 1) * 50;

    const props: any = {
      pageNo: pageNo,
      data: final_data,
      func: set_final_data,
      setTotalPages: setTotalPages,
      setTotalRecords: setTotalRecords,
      isRefresh: isRefresh,
      setRefresh: setRefresh,
      setRefreshToast: setRefreshToast,
      setDeviceCnt: setDeviceCnt,
      saveBtnClicked: saveBtnClicked,
      setGroupDeviceCnt: setGroupDeviceCnt,
      setPreviousSelectedGroups: setPreviousSelectedGroups,
      setExportDetails: setExportDetails,
      exportBtnClicked: exportBtnClicked,
      searchVal: searchVal,
      tenant: tenantName,
      automationName: contextValue.automationDetails.automationName,
      dartNo: dartNo,
      automationType: contextValue.automationDetails.automationType,
      setExportBtnClicked: setExportBtnClicked,
      automationId: contextValue?.automationDetails?.id,
    }

    !saveBtnClicked && Remediations_func(props);
  }, [isRefresh, searchVal, saveBtnClicked, currentPageNo, exportBtnClicked]);

  useEffect(() => {
    const props: any = {
      saveBtnClicked: saveBtnClicked,
      setSaveBtnClicked: setSaveBtnClicked,
      setmessagebar1: setmessagebar1,
      setmessagebar2: setmessagebar2,
      setToastMessage: setToastMessage,
      groupAttachment: attachmentGrp,
      groupDetachment: detachmentGrp,
      setErrorToast: setErrorToast,
      setAllAttachmentGrp: setAllAttachmentGrp,
      setAllDetachmentGrp: setAllDetachmentGrp,
      setAttachmentStatus: setAttachmentStatus,
      tenant: tenantName,
      dartNo: dartNo,
      selectedRowIdInTable: contextValue.selectedRowIdInTable,
      automationName: contextValue.automationDetails.automationName,
      automationType: automationType,
      automationId: contextValue?.automationDetails?.id,
    }

    saveBtnClicked && (automationType === 'selfhelp' || automationType === 'proactive' || automationType === 'scheduler' || automationType === 'usersurvey' || automationType === 'policy' || automationType === 'autoheal' || automationType === 'data_collection' || automationType === 'default_dart' || automationType === 'app policy') && Remediations_assignment_func(props);
  }, [saveBtnClicked, attachmentGrp, detachmentGrp]);

  return (
    <>
      <FullScreen handle={handle} className="fullScreenBackgroundColor">
        <StackItem grow shrink style={BreadcrumbsBorder}>
          <Stack tokens={{childrenGap:10}} horizontal>
            <StackItem grow shrink>
              <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                <StackItem> <Text></Text> </StackItem>
                <StackItem grow shrink>
                  {/* <Breadcrumbs pageName="Devices" subPageName={automationType === 'policy' ? "Compliance Policies" : (automationType === 'data_collection' || automationType === 'default_dart') ? "Data Collection" : automationType === 'usersurvey' ? "User Survey" : automationType === 'app policy' ? "Conditional Access" : "Assignment" } subPageLink={(automationType === "data_collection" || automationType === "default_dart") ? "/manage/devices/datacollection" : "/manage/devices/remediation"} />  */}
                  <Breadcrumbs
                    items={[
                        { name: "Manage", link: "/home" },
                        { name: "Devices", link: "/manage/devices/overview" },
                        { 
                        name: localStorage.getItem('assignmentType') === 'datacollection'
                          ? 'Data Collection'
                          : localStorage.getItem('assignmentType') === 'conditionalaccess'
                            ? 'Conditional Access'
                            : localStorage.getItem('assignmentType') === 'policy'
                              ? 'Compliance Policies'
                              : localStorage.getItem('assignmentType') === 'survey'
                                ? 'User Survey'
                                : 'Assignment',
                        link: localStorage.getItem('assignmentType') === 'datacollection'
                          ? "/manage/devices/datacollection" : "/manage/devices/remediation"
                      },
                      { name: contextValue.automationDetails.automationName, link: "#" },
                      { name: "Assignment", link: "#" },

                    ]}
                  />
                </StackItem>
              </Stack>
            </StackItem>
            {/* <StackItem grow shrink>
              <Stack horizontalAlign="end">
                <StackItem grow shrink>
                  <FullScreenButton handle={handle} />
                </StackItem>
              </Stack>
            </StackItem> */}
          </Stack>
        </StackItem>
        <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
          <StackItem style={DynamicBoxingCSS}>
            {/* pages code starts here */}
            <Stack style={DynamicBoxingCSS}>
              <FluentProvider style={parentHome} theme={dashboardTheme}>
                <Stack style={parentHome} horizontal>
                  {/* SPACING BETWEEN INLINE AND PAGE */}
                  <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={AuditPages("Assignment")} />
                  <StackItem style={DynamicBoxingCSS}>
                    <Stack>{isProgressLoading && <ProgressBar />}</Stack>
                    <Stack className={isProgressLoading ? 'disabled-opacity' : ''} style={DynamicBoxingCSS} tokens={{ childrenGap: 10 }}>
                      <StackItem>
                        <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                        <Divider />
                      </StackItem>
                      <StackItem style={wraperStyle}>
                        <StackItem>
                          <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                            <Stack horizontal tokens={{ childrenGap: 10 }}>
                              <SearchBar searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                            </Stack>
                            <StackItem>
                              <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} defaultSelected={defaultSelectedRows} />
                            </StackItem>
                            {/* <StackItem>
                              <MenuDropdown
                                btn=
                                {
                                  <MenuButton shape="circular" size="small">
                                    <Stack tokens={{childrenGap:5}} horizontal>
                                      <Filter20Filled {...primaryIcon}/>
                                      <Body1> Filter </Body1>
                                    </Stack>
                                  </MenuButton>
                                }
                                itemVal=
                                {
                                  <>
                                    <Body1Strong> Add a Filter </Body1Strong>
                                    <Divider/>
                                    <MenuList>
                                      <Stack tokens={{childrenGap:5}}>
                                        <StackItem><Text></Text></StackItem>
                                        <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                        <DropdownComponent optionData={columns}/>
                                        <StackItem> <Divider /> </StackItem>
                                        <StackItem> <Caption1> Value </Caption1> </StackItem>
                                        <DropdownComponent optionData={columns}/>
                                        <StackItem> <Divider /> </StackItem>
                                        <Stack tokens={{childrenGap:10}} horizontal>
                                          <StackItem>
                                            <Button shape="circular" appearance="primary">
                                              <Caption1> Apply </Caption1>
                                            </Button>
                                          </StackItem>
                                          <StackItem>
                                            <Button shape="circular">
                                              <Caption1> Cancel </Caption1>
                                            </Button>
                                          </StackItem>
                                        </Stack>
                                      </Stack>
                                    </MenuList>
                                  </>
                                }
                              />
                            </StackItem>
                            <StackItem>
                              <Button shape="circular" appearance="subtle" size="small">
                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                  <StackItem> <FilterDismiss20Filled/> </StackItem>
                                  <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                </Stack>
                              </Button>
                            </StackItem> */}
                          </Stack>
                          {tableData.length > 0 &&
                            <Stack horizontal enableScopedSelectors horizontalAlign="end">
                              <StackItem>
                                <Caption1> Showing {(currentPageNo - 1) * 50 + 1} to {currentPageNo * 50 > totalRecords ? totalRecords : currentPageNo * 50} of {totalRecords} Records </Caption1>
                              </StackItem>

                            </Stack>
                            // : 
                            // <Stack horizontalAlign="center" tokens={{childrenGap: 15}}>
                            //   <StackItem><Text></Text></StackItem>
                            //   <StackItem> <Text size={500}> No data available </Text> </StackItem>
                            // </Stack>
                          }
                        </StackItem>
                        <InfoBar showSpaces={true} title={"If you choose the option 'All devices' The policy will be applied universally to all devices and will become detached from Devices groups."} />
                      </StackItem>

                      {/* {saveBtnClicked && automationType === 'autoheal' && 
                        <Remediations_autoheal_func
                          saveBtnClicked={saveBtnClicked}
                          setSaveBtnClicked={setSaveBtnClicked}
                          setmessagebar1={setmessagebar1}
                          setmessagebar2={setmessagebar2}
                          setToastMessage={setToastMessage}
                          groupAttachment={attachmentGrp}
                          groupDetachment={detachmentGrp}
                          setErrorToast={setErrorToast}
                          setAllAttachmentGrp={setAllAttachmentGrp}
                          setAllDetachmentGrp={setAllDetachmentGrp}
                        />
                      } */}

                      {/* {saveBtnClicked && (automationType === 'selfhelp' || automationType === 'proactive') && 
                        <Remediations_selfhelp_func
                          saveBtnClicked={saveBtnClicked}
                          setSaveBtnClicked={setSaveBtnClicked}
                          setmessagebar1={setmessagebar1}
                          setmessagebar2={setmessagebar2}
                          setToastMessage={setToastMessage}
                          groupAttachment={attachmentGrp}
                          groupDetachment={detachmentGrp}
                          setErrorToast={setErrorToast}
                          setAllAttachmentGrp={setAllAttachmentGrp}
                          setAllDetachmentGrp={setAllDetachmentGrp}
                          setAttachmentStatus={setAttachmentStatus}
                        />
                      } */}

                      {/* {saveBtnClicked && automationType === 'scheduler' && 
                        <Remediations_scheduler_func
                          saveBtnClicked={saveBtnClicked}
                          setSaveBtnClicked={setSaveBtnClicked}
                          setmessagebar1={setmessagebar1}
                          setmessagebar2={setmessagebar2}
                          setToastMessage={setToastMessage}
                          groupAttachment={attachmentGrp}
                          groupDetachment={detachmentGrp}
                          setErrorToast={setErrorToast}
                          setAllAttachmentGrp={setAllAttachmentGrp}
                          setAllDetachmentGrp={setAllDetachmentGrp}
                        />
                      } */}

                      {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={columns} defaultSelected={defaultSelectedRows} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                    </Stack>
                  </StackItem>
                </Stack>
              </FluentProvider>
            </Stack>
            <StackItem>
              {
                messagebar1 &&
                <ToastComponent
                  setmessagebar={setmessagebar1}
                  toastIntent="warning"
                  position="top"
                  title="Please confirm your decision to proceed with change. the policy will be assigned to 'All devices'."
                  footer={
                    <>
                      <Button shape="circular" appearance="primary" onClick={handleBothSetMessage}> Confirm </Button>
                      <Button shape="circular" onClick={() => { setmessagebar1(false); }}> Cancel </Button>
                    </>
                  }
                />
              }
            </StackItem>
            <OverLay overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} overlayData="Census" />
          </StackItem>

          {messagebar2 &&
            <ToastComponent
              setmessagebar={setmessagebar2}
              toastIntent="success"
              position="top-end"
              title="Success"
              message={toastMessage}
              footer=""
            />
          }

          {refreshToast &&
            <ToastComponent
              setmessagebar={setIsToast}
              isToastEnabled={refreshToast}
              toastIntent="success"
              position="top-end"
              title="Success"
              message={'Data Table Refreshed'}
              footer=""
            />
          }

          {errorToast &&
            <ToastComponent
              setmessagebar={setErrorToast}
              toastIntent="error"
              position="top-end"
              title="Failed"
              message={toastMessage}
              footer=""
              setProgressLoading={setProgressLoading}
            />
          }
          <StackItem><Text></Text></StackItem>
        </Stack>
      </FullScreen>
    </>
  );
};